import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=699faefb&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699faefb",
  null
  
)

export default component.exports